<div class="text-center text-uppercase" *ngIf="false" >
  <h4>Valor Máximo da Parcela: {{ parcelaMax || 0 | currency:'BRL':'symbol':'1.2-2'}} </h4>
</div>
<div class="row quotas" [formGroup]="formParent">
  <div *ngFor="let parcela of parcelas" [class]="getParcelasClass()">
    <input
      type="radio"
      formControlName="quantidadeParcelas"
      [checked]="formParent.get('quantidadeParcelas').value == parcela.numeroParcelas"
      [id]="separador + parcela.numeroParcelas"
      [value]="parcela.numeroParcelas" />
    <label [for]="separador + parcela.numeroParcelas">
      <span>
        {{ parcela.numeroParcelas }}x<br>{{ parcela.valor | currency:'BRL':'symbol':'1.2-2'}}
      </span>
    </label>
  </div>
</div>

<app-modal-message #modalMessage title="Atenção!" message="Parcela acima do percentual permitido." [hideClose]="true"></app-modal-message>
